import { useEffect, useState } from "react";

/** A Blob/File URL whose lifetime is exactly the committed React lifetime. */
export function useObjectUrl(blob: Blob | File | null | undefined, enabled = true): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    if (!enabled || !blob) {
      queueMicrotask(() => {
        if (active) setUrl(null);
      });
      return () => {
        active = false;
      };
    }

    const nextUrl = URL.createObjectURL(blob);
    queueMicrotask(() => {
      if (active) setUrl(nextUrl);
    });
    return () => {
      active = false;
      URL.revokeObjectURL(nextUrl);
    };
  }, [blob, enabled]);

  return url;
}
